import { AxiosPromise } from 'axios';
import { csttFacadeApi } from '@cd/sdds-common-components-react';

const logUiEvent = (requestPayload: any): AxiosPromise<any> =>
  csttFacadeApi.post('/csttfacade/audit/ui-events', requestPayload);

export { logUiEvent }